export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const SET_WARNING = "SET_WARNING";
export const SET_INFO = "SET_INFO";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const GET_PLATFORM = "GET_PLATFORM";
export const SET_ERROR_DETAIL = "SET_ERROR_DETAIL";
export const SET_LOADING = "SET_LOADING";
export const SET_SELECT_STORICO = "SET_SELECT_STORICO";
